export const translations = {
  "en-US": {
    "cards.title": "Card payment",
    "cards.cardNumber": "Card number",
    "cards.expiryDate": "Expiry date",
    "cards.securityCode3Digits": "Security code",
    "cards.securityCode3DigitsOptional": "Security code (optional)",
    "cards.securityCode3DigitsInfo": "3-digit on the back of the card",
    "cards.securityCode4DigitsInfo": "4-digit on the back of the card",
    "cards.storePaymentMethod": "Store payment information",
    "googlePay.title": "Google Pay",
    "applePay.title": "Apple Pay",
    "stored-cards.expiryDate": "Expiry date",
    "stored-cards.securityCode3Digits": "Security code",
    "stored-cards.securityCode3DigitsOptional": "Security code (optional)",
    "stored-cards.securityCode3DigitsInfo": "3-digit on the back of the card",
    "stored-cards.securityCode4DigitsInfo": "4-digit on the back of the card",
    "stored-cards.removeStoredCard": "Remove",
    "stored-cards.removeStoredCardQuestion": "Remove stored payment method?",
    "stored-cards.removeStoredCardQuestionYesRemove": "Yes, remove",
    "stored-cards.removeStoredCardQuestionCancel": "Cancel",

    "success.paymentAuthorized": "Payment authorized",

    "error.unknownError": "Unknown error occurred",
    "error.failedToInitializeStraumurWebComponent": "Failed to initialize Straumur Web component",
    "error.failedToInitializePaymentMethods": "Failed to initialize payment methods",
    "error.failedToSubmitPayment": "Failed to submit payment",
    "error.paymentFailed": "Payment failed",
    "error.paymentUnsuccessful": "Payment unsuccessful",
    "error.failedToSubmitPaymentDetails": "Failed to submit payment details",
    "error.paymentDetailsFailed": "Payment details failed",
    "error.googlePayNotAvailable": "Google Pay not available",
    "error.applePayNotAvailable": "Apple Pay not available",
    "error.failedToSubmitRemoveStoredPaymentCard": "Failed to remove stored payment card",
    "error.failedToRemoveStoredPaymentCard": "Stored payment card was not removed",
  },
  "is-IS": {
    "cards.title": "Greiða með korti",
    "cards.cardNumber": "Kortanúmer",
    "cards.expiryDate": "Gildisdagur",
    "cards.securityCode3Digits": "Öryggiskóði",
    "cards.securityCode3DigitsOptional": "Öryggiskóði (valkvætt)",
    "cards.securityCode3DigitsInfo": "3 tölustafir aftan á kortinu",
    "cards.securityCode4DigitsInfo": "4 tölustafir aftan á kortinu",
    "cards.storePaymentMethod": "Vista greiðsluupplýsingar",
    "googlePay.title": "Google Pay",
    "applePay.title": "Apple Pay",
    "stored-cards.expiryDate": "Gildisdagur",
    "stored-cards.securityCode3Digits": "Öryggiskóði",
    "stored-cards.securityCode3DigitsOptional": "Öryggiskóði (valkvætt)",
    "stored-cards.securityCode3DigitsInfo": "3 tölustafir aftan á kortinu",
    "stored-cards.securityCode4DigitsInfo": "4 tölustafir aftan á kortinu",
    "stored-cards.removeStoredCard": "Fjarlægja",
    "stored-cards.removeStoredCardQuestion": "Fjarlægja geymdan greiðslumáta?",
    "stored-cards.removeStoredCardQuestionYesRemove": "Já, fjarlægja",
    "stored-cards.removeStoredCardQuestionCancel": "Hætta við",

    "success.paymentAuthorized": "Greiðsla samþykkt",

    "error.unknownError": "Óþekkt villa kom upp",
    "error.failedToInitializeStraumurWebComponent": "Mistókst að sækja Straumur Web hluta",
    "error.failedToInitializePaymentMethods": "Mistókst að sækja greiðslumáta",
    "error.failedToSubmitPayment": "Mistókst að senda greiðslu",
    "error.paymentFailed": "Greiðsla mistókst",
    "error.paymentUnsuccessful": "Greiðsla ekki tekin",
    "error.failedToSubmitPaymentDetails": "Mistókst að senda greiðsluupplýsingar",
    "error.paymentDetailsFailed": "Mistókst að sækja greiðsluupplýsingar",
    "error.googlePayNotAvailable": "Google Pay ekki í boði",
    "error.applePayNotAvailable": "Apple Pay ekki í boði",
    "error.failedToSubmitRemoveStoredPaymentCard": "Mistókst að fjarlægja geymdan greiðslumáta",
    "error.failedToRemoveStoredPaymentCard": "Geymdur greiðslumáti var ekki fjarlægður",
  },
};

export type Language = keyof typeof translations;
export type TranslationKey = keyof (typeof translations)["en-US"] | keyof (typeof translations)["is-IS"];
